/* ============================================================
   VÉLOUTÉE × Klaviyo — Connecteur de formulaires
   ------------------------------------------------------------
   Connecte automatiquement tous les formulaires marqués
   data-klaviyo-form="true" à Klaviyo via leur API publique.
   © 2026 VÉLOUTÉE
   ============================================================ */

(function () {
  'use strict';

  const KLAVIYO_PUBLIC_KEY = 'TxwwXDV';
  const KLAVIYO_API_URL = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY;
  const KLAVIYO_REVISION = '2024-10-15';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKlaviyoForms);
  } else {
    initKlaviyoForms();
  }

  function initKlaviyoForms() {
    const forms = document.querySelectorAll('form[data-klaviyo-form="true"]');
    forms.forEach(function (form) {
      form.addEventListener('submit', handleSubmit);
    });
  }

  function handleSubmit(event) {
    event.preventDefault();

    const form = event.target;
    const listId = form.getAttribute('data-klaviyo-list');
    const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    const originalBtnHTML = submitBtn ? submitBtn.innerHTML : '';

    const emailInput = form.querySelector('input[type="email"], input[name="email"]');
    const firstNameInput = form.querySelector('input[name="first_name"], input[name="prenom"], input[name="firstname"]');

    const email = emailInput ? emailInput.value.trim() : '';
    const firstName = firstNameInput ? firstNameInput.value.trim() : '';

    if (!email || !isValidEmail(email)) {
      showError(form, 'Adresse email invalide.');
      return;
    }

    if (!listId) {
      showError(form, 'Configuration manquante. Contacte-nous.');
      console.error('VELOUTEE × Klaviyo: data-klaviyo-list manquant sur le formulaire.');
      return;
    }

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = 'Envoi en cours…';
      submitBtn.style.opacity = '0.7';
      submitBtn.style.cursor = 'wait';
    }

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: form.getAttribute('data-source') || 'Site VÉLOUTÉE',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: firstName || null,
                properties: {
                  source: form.getAttribute('data-source') || 'Site VÉLOUTÉE',
                  inscrit_le: new Date().toISOString()
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    fetch(KLAVIYO_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': KLAVIYO_REVISION
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (response.status === 202 || response.ok) {
          showSuccess(form, firstName);
        } else {
          return response.json().then(function (data) {
            throw new Error(data.errors ? data.errors[0].detail : 'Une erreur est survenue.');
          });
        }
      })
      .catch(function (error) {
        console.error('VELOUTEE × Klaviyo:', error);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalBtnHTML;
          submitBtn.style.opacity = '1';
          submitBtn.style.cursor = 'pointer';
        }
        showError(form, "Une erreur est survenue. Vérifie ton email et réessaie.");
      });
  }

  function isValidEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  function showError(form, message) {
    let errorEl = form.querySelector('.klaviyo-error-message');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.className = 'klaviyo-error-message';
      errorEl.style.cssText = 'color:#B85450; font-size:13px; margin:14px 0 0 0; text-align:center; font-family:inherit;';
      form.appendChild(errorEl);
    }
    errorEl.textContent = message;
    setTimeout(function () {
      if (errorEl && errorEl.parentNode) errorEl.remove();
    }, 6000);
  }

  function showSuccess(form, firstName) {
    const caramelColor = '#C8884A';
    const noirColor = '#0B0804';
    const greeting = firstName ? firstName + ', merci 🤍' : 'Merci 🤍';

    const successHTML =
      '<div class="klaviyo-success-message" style="text-align:center; padding:40px 24px; font-family:inherit; animation:veloutee-fadein 0.6s ease;">' +
      '  <div style="font-family:\'Cormorant Garamond\', Georgia, serif; font-style:italic; font-size:36px; color:' + noirColor + '; margin:0 0 18px 0; line-height:1.2;">' +
      '    ' + greeting +
      '  </div>' +
      '  <div style="font-family:\'DM Sans\', Arial, sans-serif; font-size:15px; line-height:1.7; color:#3a3530; max-width:380px; margin:0 auto 12px auto;">' +
      '    Ton guide arrive dans ta boîte mail dans quelques instants.' +
      '  </div>' +
      '  <div style="font-family:\'DM Sans\', Arial, sans-serif; font-size:13px; color:#8a7a68; max-width:380px; margin:0 auto 32px auto; line-height:1.6;">' +
      '    Pense à vérifier tes spams ou ton onglet « Promotions » et à ajouter <strong style="color:' + caramelColor + ';">bonjour@veloutee.ca</strong> à tes contacts.' +
      '  </div>' +
      '  <a href="/" style="display:inline-block; padding:16px 38px; background-color:' + caramelColor + '; color:#FFFFFF; text-decoration:none; font-family:\'DM Sans\', Arial, sans-serif; font-size:12px; font-weight:600; letter-spacing:3px; text-transform:uppercase; border-radius:2px; transition:opacity 0.3s ease;">' +
      '    Continuer sur le site →' +
      '  </a>' +
      '</div>' +
      '<style>@keyframes veloutee-fadein { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }</style>';

    form.outerHTML = successHTML;

    setTimeout(function () {
      const successEl = document.querySelector('.klaviyo-success-message');
      if (successEl) {
        successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  }
})();